import { Product } from './components/Catalog/Product/Product';

export const CatalogList = ({ lisArt, dataClient }) =>
  lisArt?.map((articulo) => {
    return (
      <Product articulo={articulo} key={articulo.id} dataClient={dataClient} />
    );
  });
